module.exports = __webpack_public_path__ + "img/ox.b5d6d086.svg";